import { createFileRoute } from '@tanstack/react-router';

import { DmaValueChainPage } from '@/features/esg/dma/components/DmaValueChainPage';

export const Route = createFileRoute('/_authenticated/esg/double-materiality/$assessmentId/value-chain')({
  component: DmaValueChainRoute,
});

function DmaValueChainRoute() {
  const { assessmentId } = Route.useParams();
  return <DmaValueChainPage assessmentId={assessmentId} />;
}
